const myClass = class panelControl{
	constructor(){
		this.name = 'panel de control';
		console.log(this.name);
	}
}

// module.exports = myClass;
export default myClass;



// WEBPACK FOOTER //
// ./app/js/controllers/panelControl/panelControl.js